@if (shouldDisplayError) {
  <div class="field-error">
    <!-- warning icon -->
    <i class="material-icons">warning</i>
    <!-- error message -->
    @if (errorMessage) {
      <div class="error-msg pt-2 pl-2">
        {{ errorMessage }}
      </div>
    }
  </div>
}
